import { render, staticRenderFns } from "./SupportPopup.vue?vue&type=template&id=52bea71d&scoped=true&"
import script from "./SupportPopup.vue?vue&type=script&lang=js&"
export * from "./SupportPopup.vue?vue&type=script&lang=js&"
import style0 from "./SupportPopup.vue?vue&type=style&index=0&id=52bea71d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bea71d",
  null
  
)

export default component.exports